module.exports = __webpack_public_path__ + "static/EntréeJap-cae951c7cce2defd5da6a1f7692335c6.png";